import {
  Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2
} from '@angular/core';
import { environment } from '@environments/environment';
import * as routes from '@app/routes';
import { resolveEnvironmentLabel } from './environment-label';

const ENV_BAR_ROOT_CLASS = 'has-env-bar';

@Component({
  selector: 'app-env-bar',
  templateUrl: './env-bar.component.html',
  styleUrls: ['./env-bar.component.scss'],
})
export class EnvBarComponent implements OnInit, OnChanges, OnDestroy {
  @Input() showDetailsLink = false;
  @Input() impersonatedName: string | null = null;

  @Output() revertImpersonation = new EventEmitter<void>();

  detailsRoute = routes.environmentInfo();
  label: string | null = null;

  constructor(private renderer: Renderer2) {}

  get visible(): boolean {
    return !!this.label || !!this.impersonatedName;
  }

  ngOnInit(): void {
    this.label = resolveEnvironmentLabel(window.location.hostname, environment.name);
    this.syncRootClass();
  }

  ngOnChanges(): void {
    this.syncRootClass();
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.documentElement, ENV_BAR_ROOT_CLASS);
  }

  onRevert(): void {
    this.revertImpersonation.emit();
  }

  private syncRootClass(): void {
    if (this.visible) {
      this.renderer.addClass(document.documentElement, ENV_BAR_ROOT_CLASS);
    } else {
      this.renderer.removeClass(document.documentElement, ENV_BAR_ROOT_CLASS);
    }
  }
}
